import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, limit, query } from 'firebase/firestore';
import { db } from '../lib/firebase'; 
import { useNavigate } from 'react-router-dom';
import { dummy } from '../assets'; 
import './allUsers.css'; 

const TopUsers = ({ numUsersToShow = 6 }) => { 
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersQuery = query(collection(db, 'users'), orderBy('createdAt', 'desc'), limit(numUsersToShow));
        const querySnapshot = await getDocs(usersQuery);
        const usersList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          fullName: doc.data().fullName,
          email: doc.data().email,
          profilePictureUrl: doc.data().profilePictureUrl || dummy, // Use dummy image if no profile picture
        }));
        setUsers(usersList);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching users: ', error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, [numUsersToShow]);

  const handleUserClick = (userId) => {
    navigate(`/users/${userId}`); // Navigate to user detail page
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="chartTitle">
      <div className='chartTitle'>Top {numUsersToShow} Recently Registered Users</div>
      {users.length > 0 ? (
        <div className="user-list">
          {users.map(user => (
            <div key={user.id} className="user-item" onClick={() => handleUserClick(user.id)}>
              <img src={user.profilePictureUrl} alt={`${user.fullName}'s profile`} className="profile-pic" />
              <div className="user-infos">
                <h3>{user.fullName}</h3>
                <p>{user.email}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No users found</p>
      )}
    </div>
  );
};

export default TopUsers;
